<button
  [ngClass]="{
    'em-c-btn em-c-btn--small': true,
    'em-c-btn--primary': color === 'primary',
    'em-c-btn--secondary': color === 'secondary',
    'em-c-btn--inverted-red': color === 'danger'
  }"
  (click)="onClick()"
  [type]="type"
>
  <span class="em-c-btn__text">{{ text }}</span>
</button>
